<template>
  <div id="app">
    <div style="min-height: 100vh">
      <div class="header-cmp">
        <AppHeader></AppHeader>
      </div>
      <div class="content-cmp">
        <router-view/>
      </div>
    </div>
    <div class="footer-cmp">
      <div style="background: #424855">
        <AppFooterCompanyInfo></AppFooterCompanyInfo>
      </div>
      <div style="background: #353b47">
        <AppFooterCopyRight></AppFooterCopyRight>
      </div>
    </div>
  </div>
</template>

<script>
import AppHeader from './components/AppHeader'
import { UserInfo } from '../src/lib/AppConstant'
import Cookies from 'js-cookie'
import AppFooterCopyRight from './components/AppFooterCopyRight'
import AppFooterCompanyInfo from './components/AppFooterCompanyInfo'
export default {
  name: 'App',
  components: {AppFooterCompanyInfo, AppFooterCopyRight, AppHeader},
  data () {
    return {}
  },
  computed: {
    userName: function () {
      return ''
    }
  },
  created () {
    const userInfoStr = Cookies.get(UserInfo)
    if (userInfoStr != null && userInfoStr.length > 0) {
      const userInfo = JSON.parse(userInfoStr)
      this.$store.commit('SET_USERINFO', userInfo)
    }
  },
  mounted () {
  },
  methods: {
    doSomething () {
    }
  }
}
</script>

<style scoped>
  #app {
    min-width: 992px;
  }
  .header-cmp {
    border-bottom: 1px solid #e4e4e4;
    background: white;
  }
  .content-cmp {
    /*min-width: 992px;*/
    background: #FFFFFF;
  }
  .footer-cmp {
  }
</style>



// WEBPACK FOOTER //
// src/App.vue